import { Component, ComponentRef, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import moment from 'moment';
import { AUTEUR_AUTRE, Consultation } from 'src/app/utils/interfaces/new/consultation.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { DocumentType } from 'src/app/utils/interfaces/new/DocumentType';
import { PatientAccessProfil } from 'src/app/utils/interfaces/new/PatientAccessProfil';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ConsultationInfos, ModalCreateConsultationComponent } from './modal-create-consultation/modal-create-consultation.component';
import { ConsultationService } from 'src/app/services/consultation/consultation.service';
import { DocumentService } from 'src/app/services/document/document.service';
import { Document } from 'src/app/utils/interfaces/new/Document';
import { DocumentMetadata } from 'src/app/utils/interfaces/new/DocumentMetadata';
import { CreationDocumentConflictChoice, ModalConflictComponent } from './modal-conflict/modal-conflict.component';
import { UploadGedDocument } from 'src/app/utils/interfaces/new/UploadGEDDocument';
import { DisplayDocumentService } from 'src/app/services/display-document/display-document.service';
import { AskNextDocument, DisplayDocumentComponent } from '../display-document/display-document.component';
import { ProfilSubmary } from 'src/app/utils/interfaces/new/ProfilSubmary';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { LoginService } from 'src/app/services/login/login.service';
import { QuickSendMSSFragment } from '../modal/quick-send-mss/quick-send-mss.fragment';
import { DisplayContentData } from '../display-document/gedviewer/gedviewer.component';
import { UserDocumentsService } from 'src/app/services/user-documents/user-documents.service';

export interface PatientInfos {
  id: string;
  lastName: string;
  firstName: string;
  birth: Date;
}

interface FileTableDisplay {
  id: string;
  fileMeta: FileMeta;
  importerId: string;
  title: string;
  fileSize: number;
  formatFileSize: string;
  typeId: string;
  importDat: string;
  consultationId: string;
  consultationDat: string;
  consultationType: string;
  consultationTitle?: string;
  isPrivate: boolean;
}

interface FileMeta {
  file?: File;
  document?: DocumentMetadata;
}

export interface ConsultationType {
  id: string;
  libelle: string;
}

@Component({
  selector: 'app-import-documents',
  templateUrl: './import-documents.component.html',
  styleUrls: ['./import-documents.component.scss'],
})
export class ImportDocumentsComponent implements OnInit {
  @Input() public patientId: string;
  @Input() public consultations: Array<Consultation>;
  @Input() public consultationTypes: Array<ConsultationType>;
  @Input() public dmpTypes: Array<DocumentType>;
  @Input() public patientaccessProfils: Array<PatientAccessProfil>;
  @Input() public uniqueConsultation: Consultation;
  @Input() public documentWithoutConsultation: Array<DocumentMetadata>;
  @Input() isUserDocument: boolean = false;
  @Output() public importOver = new EventEmitter();

  public parentViewContainerRef: ViewContainerRef;

  public documentsTable: Paginated<FileTableDisplay>;
  public documentsTableColumn = [
    { title: 'Titre', data: 'title', isEditable: true, editType: 'string' },
    {
      title: 'Type',
      data: 'typeId',
      isEditable: true,
      editType: 'ngSelect',
      editValue: [],
      isClearableSelect: false,
    },
    { title: 'Taille', data: 'formatFileSize' },
    { title: 'Date\nimport', data: 'importDat' },
    {
      title: 'Titre\nconsultation',
      data: 'consultationId',
      isEditable: true,
      editType: 'ngSelect',
      editValue: [],
      isClearableSelect: false,
    },
    { title: 'Date\nconsultation', data: 'consultationDat' },
    { title: 'Type\nconsultation', data: 'consultationType' },
    {
      title: 'Source',
      data: 'importerId',
      isEditable: true,
      editType: 'ngSelect',
      editValue: [],
      isClearableSelect: false,
    },
    {
      title: 'Privé',
      data: 'isPrivate',
      isEditable: true,
      editType: 'boolean',
    },
    { title: 'Supprimer', data: null },
  ];
  public noConsultationDocumentsTable: Paginated<FileTableDisplay>;
  public noConsultationDocumentsTableColumn = [
    {
      title: 'Documents patient',
      data: 'title',
      isEditable: true,
      editType: 'string',
    },
  ];
  public isEdit = false;
  public formGroup: FormGroup;
  private _loadingRef: any;

  constructor(
    private _formBuilder: FormBuilder,
    private _modalSrv: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _consultationSrv: ConsultationService,
    private _documentSrv: DocumentService,
    private _userDocumentSrv: UserDocumentsService,
    private _displayDocumentSrv: DisplayDocumentService,
    private _strUtilsSrv: StringUtilsService,
    private _login: LoginService
  ) {}

  //verifier
  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      doCreateConsultation: [false],
      doSendDocumentToPatient: [false],
    });

    // Si c'est un document utilisateur, on n'a pas besoin de configurer les colonnes
    if (this.isUserDocument) {
      return;
    }

    if (this.uniqueConsultation && !this.consultations) {
      this.documentsTableColumn = [
        { title: 'Titre', data: 'title', isEditable: true, editType: 'string' },
        {
          title: 'Type',
          data: 'typeId',
          isEditable: true,
          editType: 'ngSelect',
          editValue: [],
          isClearableSelect: false,
        },
        { title: 'Taille', data: 'formatFileSize' },
        { title: 'Date\nimport', data: 'importDat' },
        { title: 'Titre\nconsultation', data: 'consultationTitle' },
        { title: 'Date\nconsultation', data: 'consultationDat' },
        { title: 'Type\nconsultation', data: 'consultationType' },
        {
          title: 'Source',
          data: 'importerId',
          isEditable: true,
          editType: 'ngSelect',
          editValue: [],
          isClearableSelect: false,
        },
        {
          title: 'Privé',
          data: 'isPrivate',
          isEditable: true,
          editType: 'boolean',
        },
        { title: 'Supprimer', data: null },
      ];
    }

    const typeColumnTable = this.documentsTableColumn.find(
      (c) => c.data === 'typeId'
    );
    if (typeColumnTable && this.dmpTypes) {
      for (const t of this.dmpTypes) {
        typeColumnTable.editValue.push({ id: t.id, libelle: t.type });
      }
    }

    if (this.consultations) {
      const consultationColumnTable = this.documentsTableColumn.find(
        (c) => c.data === 'consultationId'
      );
      for (const c of this.consultations) {
        consultationColumnTable.editValue.push({ id: c.id, libelle: c.titre });
      }
    }

    const patientAccessProfilsColumnTable = this.documentsTableColumn.find(
      (c) => c.data === 'importerId'
    );
    if (patientAccessProfilsColumnTable && this.patientaccessProfils) {
      for (const p of this.patientaccessProfils) {
        patientAccessProfilsColumnTable.editValue.push({
          id: p.id,
          libelle: `${p.qualite} ${
            p.nom
          } ${this._strUtilsSrv.uppercaseFirstCharString(p.prenom)}`,
        });
      }
    }

    if (this.documentWithoutConsultation) {
      this._initTableDisplayNoConsultationDocuments(
        this.documentWithoutConsultation
      );
      this.documentsTable = {
        objects: [],
        page: 0,
        perpage: 0,
        total: 0,
      };
    }
  }

  //Fonction qui gère la sélection des documents, les types et volumes autorisés
  public selectDocuments(): void {
    const body = document.getElementsByTagName('body')[0];
    const inputElem = document.createElement('input');
    inputElem.type = 'file';
    inputElem.setAttribute('multiple', 'true');
    inputElem.accept = this.getAcceptedTypes().join(','); // Ajout des types acceptés
    body.appendChild(inputElem);

    inputElem.addEventListener('change', (event: any) => {
      const files = event.target.files as FileList;
      const validFiles: File[] = [];
      const notUploadedDocsBecauseOfUnknownType: File[] = [];
      const notUploadedDocsBecauseOfSize: File[] = [];
      const forbiddenDocTypes: File[] = [];
      const acceptedTypes = this.getAcceptedTypes();

      for (let i = 0; i < files.length; i++) {
        const file = files.item(i);

        // Vérification du type de fichier
        if (
          !file.type ||
          !acceptedTypes.includes(file.type) ||
          file.type === ''
        ) {
          notUploadedDocsBecauseOfUnknownType.push(file);
          continue; // Passer au fichier suivant
        }

        // Vérification des types interdits
        if (
          file.type === 'application/x-msdownload' ||
          file.type === 'application/x-apple-diskimage'
        ) {
          forbiddenDocTypes.push(file);
          continue;
        }

        // Vérification de la taille du fichier (10 Mo max)
        if (file.size > 10 * 1024 * 1024) {
          notUploadedDocsBecauseOfSize.push(file);
          continue;
        }

        validFiles.push(file);
      }

      if (validFiles.length > 0) {
        this._addFilesToTable(validFiles); // Ajout à la table si des fichiers sont valides
      }

      let errorMessage: string | undefined = undefined;
      if (notUploadedDocsBecauseOfUnknownType.length > 0) {
        errorMessage = `Les documents suivants ne peuvent pas être utilisés\ncar il est impossible de déterminer leur type : ${notUploadedDocsBecauseOfUnknownType.map(
          (d) => `\n  - ${d.name}`
        )}`;
      }
      if (forbiddenDocTypes.length > 0) {
        errorMessage = errorMessage ? `${errorMessage}\n\n` : '';
        errorMessage += `Les documents suivants ne peuvent pas être utilisés\ncar leur type est interdit : ${forbiddenDocTypes.map(
          (d) => `\n  - ${d.name}`
        )}`;
      }
      if (notUploadedDocsBecauseOfSize.length > 0) {
        errorMessage = errorMessage ? `${errorMessage}\n\n` : '';
        errorMessage += `Les documents suivants ne peuvent pas être utilisés\ncar ils font plus de 10Mo : ${notUploadedDocsBecauseOfSize.map(
          (d) => `\n  - ${d.name}`
        )}`;
      }

      if (errorMessage) {
        this._modalSrv.openAlert(
          this._viewContainerRef,
          'Ajouts impossibles',
          errorMessage
        );
      }

      body.removeChild(inputElem);
    });

    inputElem.click();
  }

  private getAcceptedTypes(): string[] {
    return [
      'application/pdf',
      'image/png',
      'image/jpeg',
      'image/tif',
      'image/tiff',
      'application/vnd.ms-excel', // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'application/vnd.ms-excel.sheet.macroEnabled.12', // .xlsm
      'application/msword', // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.oasis.opendocument.text',
      'application/zip',
    ];
  }

  public updateFilesInfos(event: Array<FileTableDisplay>): void {
    if (
      this.documentsTable &&
      this.documentsTable.objects &&
      this.documentsTable.objects.length > 0
    ) {
      for (const p of this.documentsTable.objects) {
        const row = event.find((r) => r.id === p.id);
        if (row) {
          if (!this.uniqueConsultation && row.consultationId) {
            const consultation = this.consultations.find(
              (c) => c.id === row.consultationId
            );
            const consulationType = this._getConsultationTypeByIdFromArray(
              consultation.typeConsultation
            );
            p.consultationDat = consultation.date.toString();
            p.consultationType = consulationType
              ? consulationType
              : 'Aucune information';
            p.consultationId = row.consultationId;
          }

          p.typeId = row.typeId;
          p.importerId = row.importerId;
          p.isPrivate = row.isPrivate;
          p.title = row.title;
        }
      }
    }

    this.isEdit = !this.isEdit;
  }

  public async removeDocument(file: FileTableDisplay): Promise<void> {
    const modal = this._modalSrv.openModalConfirmation(
      this._viewContainerRef,
      'Confirmation',
      'Voulez-vous supprimer ce fichier ?'
    );
    modal.instance.closeEmitter.subscribe(async (res: boolean) => {
      if (res) {
        this.documentsTable.objects.splice(
          this.documentsTable.objects.findIndex((p) => p.id === file.id),
          1
        );
      }
    });
  }

  public async sendDocumentToPatient() {
    return new Promise(async (resolve, reject) => {
      if (this._viewContainerRef) {
        const quickSendMSS = this._modalSrv.openModal(
          this._viewContainerRef,
          QuickSendMSSFragment,
          [
            { name: 'idPatient', value: this.patientId },
            { name: 'title', value: this.documentsTable.objects[0].title },
            {
              name: 'content',
              value:
                'Envoi automatique du document ' +
                this.documentsTable.objects[0].title,
            },
            {
              name: 'pieceJointe',
              value: {
                fileName: this.documentsTable.objects[0].title,
                file: await this._documentSrv.convertFileToBase64(
                  this.documentsTable.objects[0].fileMeta.file
                ),
                size: this.documentsTable.objects[0].fileSize,
                contentType: this.documentsTable.objects[0].fileMeta.file.type,
              },
            },
            { name: 'envoiPatient', value: true },
          ]
        );
        const sub = quickSendMSS.instance.closeEmitter.subscribe(
          async (response) => {
            sub.unsubscribe();
            quickSendMSS.destroy();
            resolve(response);
          }
        );
      }
    });
  }

  public async validSelectUserDocuments(): Promise<void> {
      let loading: any | undefined;

    try {
      // Cas : un seul fichier → modale de renommage puis enregistrement
      if (this.documentsTable.objects.length === 1) {
        const file = this.documentsTable.objects[0];

        const newName = await new Promise<string | undefined>((resolve) => {
          const modalRef = this._modalSrv.openModalAddEdit(
            'Importer un document',
            this._viewContainerRef,
            {
              inputs: [
                {
                  id: 'fichierName',
                  label: 'Nom du fichier',
                  placeholder: '',
                  type: 'text',
                  variable: 'getFichierName',
                  required: true,
                  style: { width: '300px' },
                },
              ],
            },
            false,
            {
              getFichierName: file.title || file.fileMeta?.file?.name,
            },
            undefined,
            {
              validateButtonText: 'Valider',
            }
          );

          const serviceSub = this._modalSrv.closeEmitter.subscribe(
            (resp: any) => {
              if (
                resp &&
                resp.loadingModal &&
                resp.addEditFragment === modalRef
              ) {
                this._modalSrv.close(resp.loadingModal);
                serviceSub.unsubscribe();
              }
            }
          );

          const sub = modalRef.instance.closeEmitter.subscribe((resp) => {
            resolve(resp?.getFichierName);
            sub.unsubscribe();
            try {
              serviceSub.unsubscribe();
            } catch {}
            this._modalSrv.close(modalRef);
          });
        });

        if (newName) {
          file.title = newName;
          loading = loading || this._openLoading();
          await this._userDocumentSrv.createUserDocument(
            {
              title: file.title,
              fileName: file.fileMeta.file.name,
              content: await this._documentSrv.convertFileToBase64(
                file.fileMeta.file
              ),
              mime: file.fileMeta.file.type,
            });

          this._closeLoading();
          this.importOver.emit();
        }
      } else {
        loading = loading || this._openLoading();
        for (const file of this.documentsTable.objects) {
          await this._userDocumentSrv.createUserDocument(
            {
              title: file.title,
              fileName: file.fileMeta.file.name,
              content: await this._documentSrv.convertFileToBase64(
                file.fileMeta.file
              ),
              mime: file.fileMeta.file.type,
            });
        }
        this._closeLoading();
        this.importOver.emit();
      }
    } catch (e: any) {
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Erreur',
        e?.message ||
          "Une erreur est survenue lors de l'enregistrement de ces fichiers"
      );
    } finally {
      if (loading) this._closeLoading();
      if (this.documentsTable?.objects) this.documentsTable.objects = [];
    }
  }
  //bloquer
  public async validFilesSelect(): Promise<void> {
    let loading: any | undefined;

    try {
      let consultationId: string | undefined;

      // Cas : un document et envoi au patient (ouvre une modale) → pas de loader ici
      if (
        this.documentsTable?.objects?.length === 1 &&
        this.formGroup.get('doSendDocumentToPatient').value
      ) {
        await this.sendDocumentToPatient();
      }

      // Cas : création d'une consultation → d'abord recueillir les infos via modale, puis loader seulement pour l'appel réseau
      if (this.formGroup.get('doCreateConsultation').value) {
        const consultationInfos = await this.createConsultation();
        if (!consultationInfos) return;

        const currentProfil = this._login.getCurrentProfil();
        loading = loading || this._openLoading();
        consultationId = await this._consultationSrv.create({
          date: consultationInfos.consultationDate,
          titre: consultationInfos.consultationTitle,
          idPatient: this.patientId,
          typeConsultation: consultationInfos.consultationType || undefined,
          auteur: {
            id: currentProfil?.id,
            autre: !currentProfil?.id ? AUTEUR_AUTRE : undefined,
          },
        });
      }

      // Cas : un seul fichier → modale de renommage puis enregistrement
      if (this.documentsTable.objects.length === 1) {
        const file = this.documentsTable.objects[0];

        const newName = await new Promise<string | undefined>((resolve) => {
          const modalRef = this._modalSrv.openModalAddEdit(
            'Importer un document',
            this._viewContainerRef,
            {
              inputs: [
                {
                  id: 'fichierName',
                  label: 'Nom du fichier',
                  placeholder: '',
                  type: 'text',
                  variable: 'getFichierName',
                  required: true,
                  style: { width: '300px' },
                },
              ],
            },
            false,
            {
              getFichierName: file.title || file.fileMeta?.file?.name,
            },
            undefined,
            {
              validateButtonText: 'Valider',
            }
          );

          const serviceSub = this._modalSrv.closeEmitter.subscribe(
            (resp: any) => {
              if (
                resp &&
                resp.loadingModal &&
                resp.addEditFragment === modalRef
              ) {
                this._modalSrv.close(resp.loadingModal);
                serviceSub.unsubscribe();
              }
            }
          );

          const sub = modalRef.instance.closeEmitter.subscribe((resp) => {
            resolve(resp?.getFichierName);
            sub.unsubscribe();
            try {
              serviceSub.unsubscribe();
            } catch {}
            this._modalSrv.close(modalRef);
          });
        });

        if (newName) {
          file.title = newName;
          loading = loading || this._openLoading();
          await this._createDocument(
            file.fileMeta,
            file.title,
            file.typeId,
            file.importerId,
            consultationId || file.consultationId
          );
          this._closeLoading();
          this.importOver.emit();
        }
      } else {
        loading = loading || this._openLoading();
        for (const f of this.documentsTable.objects) {
          await this._createDocument(
            f.fileMeta,
            f.title,
            f.typeId,
            f.importerId,
            consultationId || f.consultationId
          );
        }
        this._closeLoading();
        this.importOver.emit();
      }
    } catch (e: any) {
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Erreur',
        e?.message ||
          "Une erreur est survenue lors de l'enregistrement de ces fichiers"
      );
    } finally {
      if (loading) this._closeLoading();
      if (this.documentsTable?.objects) this.documentsTable.objects = [];
    }
  }

  private _openLoading(): any {
    if (!this._loadingRef) {
      this._loadingRef = this._modalSrv.openLoading(this._viewContainerRef);
      if (this._loadingRef && this._loadingRef.onDestroy) {
        this._loadingRef.onDestroy(() => {
          this._loadingRef = undefined;
        });
      }
    }
    return this._loadingRef;
  }

  private _closeLoading(): void {
    if (this._loadingRef) {
      this._modalSrv.close(this._loadingRef);
      this._loadingRef = undefined;
    }
  }

  public cancel(): void {
    const modal = this._modalSrv.openModalConfirmation(
      this._viewContainerRef,
      'Confirmation',
      'Les documents importés n’ont pas encore été ajoutés au dossier du patient, voulez-vous vider la liste des documents ?'
    );
    modal.instance.closeEmitter.subscribe(async (res: boolean) => {
      if (res) {
        for (const d of this.documentsTable.objects) {
          if (d.fileMeta.document) {
            this.noConsultationDocumentsTable.objects.push(
              this.convertDocumentToListElem(d.fileMeta.document)
            );
          }
        }

        this.documentsTable.objects = [];
      }
    });
  }

  public dropDocument(event: any): void {
    const item = this.noConsultationDocumentsTable.objects[event.previousIndex];

    if (this.uniqueConsultation) {
      item.consultationId = this.uniqueConsultation.id;
      item.consultationDat = this.uniqueConsultation.date.toString();
      item.consultationTitle = this.uniqueConsultation.titre;
      item.consultationType =
        this._getConsultationTypeByIdFromArray(
          this.uniqueConsultation.typeConsultation
        ) || 'Aucune information';
    }

    if (this.documentsTable) {
      this.documentsTable.objects.push(item);
      this.documentsTable.page = 0;
      this.documentsTable.perpage = 0;
      this.documentsTable.total = 0;
    } else {
      this.documentsTable = {
        objects: [item],
        page: 0,
        perpage: 0,
        total: 0,
      };
    }

    this.noConsultationDocumentsTable.objects.splice(
      this.noConsultationDocumentsTable.objects.findIndex(
        (d) => d.id === item.id
      ),
      1
    );
  }

  public async openDocument(event: FileTableDisplay): Promise<void> {
    const _getDisplayContentData = (
      doc: DocumentMetadata | Document
    ): DisplayContentData | undefined => {
      const contentData = this._displayDocumentSrv.documentToDisplayContentData(
        doc,
        this.patientId
      );

      if (!contentData.data || contentData.data === '') {
        contentData.data = (doc as any).payload;
      } else {
        this._modalSrv.openAlert(
          this._viewContainerRef,
          'Erreur',
          "Impossible d'afficher ce document"
        );
        return;
      }

      return contentData;
    };

    if (!this.isEdit) {
      const doc = event.fileMeta.document
        ? event.fileMeta.document
        : await this._fileToDocument(
            event.fileMeta.file,
            event.id,
            event.title
          );

      const displayContentData = _getDisplayContentData(doc);
      if (displayContentData) {
        const displayDocumentInstance =
          (await this._displayDocumentSrv.displayDocument(
            this._viewContainerRef,
            displayContentData
          )) as ComponentRef<DisplayDocumentComponent>;
        let currentDocumentId = event.id;
        displayDocumentInstance.instance.next.subscribe(
          async (next: AskNextDocument) => {
            const nextDocument = await this._findNextDocument(
              currentDocumentId,
              next
            );
            currentDocumentId = nextDocument.id;

            const displayNextContentData = _getDisplayContentData(nextDocument);

            if (displayNextContentData) {
              await displayDocumentInstance.instance.showNextDocument(
                displayNextContentData
              );
            }
          }
        );
      }
    }
  }

  //verifier la consultation et bloquer
  private async _createDocument(
    doc: FileMeta,
    title: string,
    typeId: string,
    authorId: string,
    consultationId?: string
  ): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let documentGEDId: string;

      try {
        if (doc.file) {
          const uploadFile: UploadGedDocument = {
            content: await this._documentSrv.convertFileToBase64(doc.file),
            fileName: doc.document ? doc.document.fileName : doc.file.name,
            mime: doc.document ? doc.document.contentType : doc.file.type,
          };
          documentGEDId = await this._documentSrv.uploadFile(uploadFile);

          await this._documentSrv.createDocument(this.patientId, {
            contentType: doc.file.type,
            fileName: doc.file.name,
            gedId: documentGEDId,
            titre: title,
            typeId,
            consultationId: consultationId ? consultationId : undefined,
            authorId,
            weight: doc.file.size,
          });
        } else if (doc.document) {
          await this._documentSrv.updateDocument(doc.document.id, {
            contentType: doc.document.contentType,
            fileName: doc.document.fileName,
            gedId: doc.document.gedId,
            titre: title,
            typeId,
            consultationId: consultationId ? consultationId : undefined,
            authorId,
            weight: doc.document.weight,
          });

          const docIndex = this.documentWithoutConsultation.findIndex(
            (dwc) => dwc.id === doc.document.id
          );
          if (docIndex > -1) {
            this.documentWithoutConsultation.splice(docIndex, 1);
          }
        }

        resolve();
      } catch (e) {
        if (e.status === 409) {
          const modal = this._modalSrv.openModal<ModalConflictComponent>(
            this._viewContainerRef,
            ModalConflictComponent
          ) as ComponentRef<ModalConflictComponent>;
          modal.instance.documentConflict = e.error.conflit;
          const sub = modal.instance.closeEmitter.subscribe(
            async (choice: CreationDocumentConflictChoice) => {
              modal.destroy();
              if (choice.doOverwrite) {
                // On overwrite le document
                await this._documentSrv.updateDocument(
                  modal.instance.documentConflict.id,
                  doc.file
                    ? {
                        contentType: doc.file.type,
                        fileName: doc.file.name,
                        gedId: documentGEDId,
                        titre: title,
                        typeId,
                        consultationId: consultationId
                          ? consultationId
                          : undefined,
                        authorId,
                        weight: doc.file.size,
                      }
                    : {
                        contentType: doc.document.contentType,
                        fileName: doc.document.fileName,
                        gedId: doc.document.gedId,
                        titre: title,
                        typeId,
                        consultationId: consultationId
                          ? consultationId
                          : undefined,
                        authorId,
                        weight: doc.document.weight,
                      },
                  true
                );
                resolve();
              } else {
                // On renomme le fichier et en tente un nouvel enregistrement
                resolve(
                  await this._createDocument(
                    doc,
                    choice.newFileName as string,
                    typeId,
                    authorId,
                    consultationId
                  )
                );
              }
              sub.unsubscribe();
            }
          );
        } else {
          reject(e);
        }
      }
    });
  }

  private async createConsultation(): Promise<ConsultationInfos | undefined> {
    return new Promise<ConsultationInfos | undefined>(
      async (resolve, reject) => {
        try {
          const modal =
            this._modalSrv.openModal<ModalCreateConsultationComponent>(
              this._viewContainerRef,
              ModalCreateConsultationComponent
            ) as ComponentRef<ModalCreateConsultationComponent>;
          const sub = modal.instance.closeEmitter.subscribe(
            (consultationInfos?: ConsultationInfos) => {
              resolve(consultationInfos);
              modal.destroy();
              sub.unsubscribe();
            }
          );
        } catch (e) {
          reject(e);
        }
      }
    );
  }

  public displayBirthDate(birth: Date): string {
    return moment(birth).format('DD/MM/YYYY');
  }

  private _addFilesToTable(files: File[]): void {
    if (this.isUserDocument) {
      this._initTableDisplayFiles(files);
      this.validSelectUserDocuments();
    } else {
      this._initTableDisplayFiles(files);
      this.validFilesSelect();
    }
  }

  private _convertFileToListElem(file: File): FileTableDisplay {
    const profil = JSON.parse(localStorage.getItem('currentProfil') as string);

    const makeFalseId = (): string => {
      let result = '';
      const characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      for (let i = 0; i < 12; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    };

    return {
      fileMeta: { file },
      title: file.name,
      formatFileSize: this.getFileSize(file.size),
      fileSize: file.size,
      typeId: 'b98d0840-13c5-44ef-a927-99610bb9174a', // ID du type par défaut ('Autre'),
      importDat: moment().format('DD/MM/YYYY'),
      consultationId: this.uniqueConsultation ? this.uniqueConsultation.id : '',
      consultationTitle: this.uniqueConsultation
        ? this.uniqueConsultation.titre
        : '',
      consultationDat: this.uniqueConsultation
        ? this.uniqueConsultation.date.toString()
        : '',
      consultationType: this.uniqueConsultation
        ? this._getConsultationTypeByIdFromArray(
            this.uniqueConsultation.typeConsultation
          ) || 'Aucune information'
        : undefined,
      importerId: profil.id,
      isPrivate: false,
      id: makeFalseId(),
    };
  }

  getFileSize(fileSize: number): string {
    const fileSizeString = fileSize.toString();
    let result: string;
    switch (true) {
      case fileSizeString.length > 0 && fileSizeString.length < 4:
        result = fileSizeString + ' octets';
        break;
      case fileSizeString.length >= 4 && fileSizeString.length < 7:
        result = Math.round((fileSize / 1000) * 10) / 10 + ' ko';
        break;
      case fileSizeString.length >= 7 && fileSizeString.length < 10:
        result = Math.round((fileSize / 1000000) * 10) / 10 + ' Mo';
        break;
      case fileSizeString.length >= 10 && fileSizeString.length < 13:
        result = Math.round((fileSize / 1000000000) * 10) / 10 + ' Go';
        break;
      case fileSizeString.length >= 13:
        result = Math.round((fileSize / 1000000000000) * 10) / 10 + ' To';
        break;
      default:
        result = 'NA';
        break;
    }
    result = result.replace('.', ',');
    return result;
  }

  private _initTableDisplayFiles(files: File[]): void {
    for (const file of files) {
      if (this.documentsTable) {
        this.documentsTable.objects.push(this._convertFileToListElem(file));
        this.documentsTable.page = 0;
        this.documentsTable.perpage = 0;
        this.documentsTable.total = 0;
      } else {
        this.documentsTable = {
          objects: [this._convertFileToListElem(file)],
          page: 0,
          perpage: 0,
          total: 0,
        };
      }
    }
  }

  private convertDocumentToListElem(
    document: DocumentMetadata
  ): FileTableDisplay {
    let consultationType: string;
    if (document.consultation) {
      consultationType = document.consultation.type;
    }

    return {
      fileMeta: { document },
      fileSize: document.weight,
      formatFileSize: this.getFileSize(document.weight),
      consultationDat: document.consultation
        ? moment(document.consultation.date).format('DD/MM/YYYY')
        : undefined,
      consultationId: document.consultation
        ? document.consultation.id
        : undefined,
      consultationType,
      consultationTitle: document.consultation
        ? document.consultation.titre
        : undefined,
      id: document.id,
      importDat: moment(document.createdAt).format('DD/MM/YYYY'),
      importerId: document.auteurCreation.id,
      isPrivate: document.isPrivate,
      title: document.titre,
      typeId: document.type.id,
    };
  }

  private _initTableDisplayNoConsultationDocuments(
    documents: Array<DocumentMetadata>
  ): void {
    const documentsTmp: Array<FileTableDisplay> = [];
    for (const d of documents) {
      documentsTmp.push(this.convertDocumentToListElem(d));
    }

    if (this.noConsultationDocumentsTable) {
      this.noConsultationDocumentsTable.objects = [...documentsTmp];
      this.noConsultationDocumentsTable.page = 0;
      this.noConsultationDocumentsTable.perpage = 0;
      this.noConsultationDocumentsTable.total = 0;
    } else {
      this.noConsultationDocumentsTable = {
        objects: documentsTmp,
        page: 0,
        perpage: 0,
        total: 0,
      };
    }
  }

  private _getConsultationTypeByIdFromArray(
    typeId?: string
  ): string | undefined {
    if (
      !typeId ||
      !this.consultationTypes ||
      this.consultationTypes.length === 0
    ) {
      return undefined;
    }

    const consultationType = this.consultationTypes.find(
      (ct) => ct.id === typeId
    );
    return consultationType ? consultationType.libelle : undefined;
  }

  private async _findNextDocument(
    currentDocumentId: string,
    next: AskNextDocument
  ): Promise<DocumentMetadata> {
    const nextDocument = async (docId: string): Promise<DocumentMetadata> => {
      const docIndex = this.documentsTable.objects.findIndex(
        (d) => d.id === docId
      );

      let nextIndex =
        next === AskNextDocument.Next ? docIndex + 1 : docIndex - 1;

      if (
        nextIndex === this.documentsTable.objects.length &&
        next === AskNextDocument.Next
      ) {
        nextIndex = 0;
      } else if (nextIndex < 0 && next === AskNextDocument.Previous) {
        nextIndex = this.documentsTable.objects.length - 1;
      }

      const nextDoc = this.documentsTable.objects[nextIndex];

      if (
        this._displayDocumentSrv.canDisplayDocument(
          nextDoc.fileMeta.document
            ? nextDoc.fileMeta.document.contentType
            : nextDoc.fileMeta.file.type
        )
      ) {
        return nextDoc.fileMeta.document
          ? nextDoc.fileMeta.document
          : await this._fileToDocument(
              nextDoc.fileMeta.file,
              nextDoc.id,
              nextDoc.title
            );
      } else {
        return nextDocument(nextDoc.id);
      }
    };

    return await nextDocument(currentDocumentId);
  }

  private async _fileToDocument(
    file: File,
    id: string,
    title: string
  ): Promise<Document> {
    return {
      payload: await this._documentSrv.convertFileToBase64(file, true),
      createdAt: moment(file.lastModified).toDate(),
      fileName: file.name,
      id,
      titre: title,
      contentType: file.type,
      auteurCreation: {} as ProfilSubmary,
      gedId: '',
      isPrivate: false,
      patientId: '',
      type: {} as DocumentType,
      version: 0,
      weight: file.size,
    };
  }
}
